import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import devDebug from "../Helpers/debug";
import { defaultTabs } from "../Services/strategies/strategyConstants";
import { useTenderStrategyStore } from "./tenderStrategyStore";
import idbKeyvalAdapter from "./1_utility";


// define the initial state
const initialState = {
  currentTab: defaultTabs,
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useTabStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      verifyTabsExist: () =>
        set((state) => {
          const newEditableStrategiesTenderStrategy =
            useTenderStrategyStore.getState().editableStrategies
              .tender_strategy;
          const newEditableStrategiesEditUser =
            useTenderStrategyStore.getState().editableStrategies.edit_user;
          const newAllStrategies = {
            ...newEditableStrategiesTenderStrategy,
            ...newEditableStrategiesEditUser,
          };

          for (let section of Object.keys(state.currentTab)) {
            if (
              !Object.keys(newAllStrategies).includes(
                `${state.currentTab[section]}`
              )
            ) {
              state.currentTab[section] = initialState.currentTab[section];
            }
          }

          //the below two tests rely on strategies never being empty
          //for edit_user, this test is currently buggy and requires manually adding a strategy
          //but only checking the strategies from the server, ignoring existing draft strategies
          //which isn't great. TODO: fix that somehow
          if (state.currentTab["edit_user"] === null) {
            state.currentTab["edit_user"] = Object.keys(
              newEditableStrategiesEditUser
            )[0];
          }

          if (state.currentTab["tender_strategy"] === null) {
            state.currentTab["tender_strategy"] = Object.keys(
              newEditableStrategiesTenderStrategy
            )[0];
          }
        }),
      setTabID: (section, id) =>
        set((state) => {
          state.currentTab[section] = `${id}`;
        }),
      moveToNextTab: (section, id) =>
        set((state) => {
          const editableStrategies =
            useTenderStrategyStore.getState().editableStrategies;
          let len = Object.keys(editableStrategies[section]).length;
          let idx = 0;
          for (let i = 0; i < len; i++) {
            if (Object.keys(editableStrategies[section])[i] === id) {
              idx = i;
            }
          }
          if (idx === 0) {
            idx = 1;
          } else if (idx === 1) {
            idx = 0;
          } else {
            idx -= 1;
          }

          state.currentTab[section] = Object.keys(editableStrategies[section])[
            idx
          ];
        }),
      resetState: () => {
        useTabStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      name: "tabs",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[tabStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[tabStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[tabStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[tabStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[tabStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[tabStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[tabStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[tabStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[tabStore] Error during rehydration. Store name: "tabStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[tabStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
